/****************************************************
 * Module Name:  commonSnackBar.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import * as React from "react";
import Button from "@mui/material/Button";
import Snackbar from "@mui/material/Snackbar";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import MuiAlert from "@mui/material/Alert";
import Slide from "@mui/material/Slide";
import Constants from "../../utility/constants";
import { useState } from "react";
import AlertTitle from "@mui/material/AlertTitle";
import FileCopyRoundedIcon from "@mui/icons-material/FileCopyRounded";
import ArrowRightAltOutlinedIcon from "@mui/icons-material/ArrowRightAltOutlined";
import { Box } from "@mui/material";

function TransitionDown(props) {
  return <Slide {...props} direction="down" />;
}

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export default function CommonSnackbar({
  message,
  variant,
  autoHide,
  show,
  handleClose,
  title,
}) {
  const [buttonText, setButtonText] = useState("Copy");

  const handleCopy = (message) => {
    navigator.clipboard.writeText(message);
    setButtonText("Copied");
  };

  const action = (
    <React.Fragment>
      <Button
        color="inherit"
        variant="outlined"
        size="small"
        onClick={() => handleCopy(message)}
        startIcon={<FileCopyRoundedIcon />}
      >
        <strong>{buttonText}</strong>
      </Button>
      <IconButton
        size="small"
        aria-label="close"
        color="inherit"
        onClick={handleClose}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </React.Fragment>
  );

  return (
    <Box style={{ zIndex: 99999999999999 }}>
      <Snackbar
        open={show}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        autoHideDuration={autoHide ? Constants.SnackBarCloseTimer : null}
        onClose={handleClose}
        TransitionComponent={TransitionDown}
      >
        {/* variant can be success, error, info, warning */}
        <Alert
          severity={variant}
          sx={{ width: "100% !important", height: "auto !importtant", maxHeight: "20rem !important" }}
          action={action}
        >
          <AlertTitle>
            {title + " "}
            <ArrowRightAltOutlinedIcon />
          </AlertTitle>
          <Box sx={{ whiteSpace: "break-spaces" }}>
            {message} {/* the message you want to display in the alert */}
          </Box>
        </Alert>
      </Snackbar>
    </Box>
  );
}
